module.exports = __webpack_public_path__ + "static/media/utk.6184b028.jpeg";